import React from 'react';

function Image(props) {
    return (
      <>
        <img className={props.class} src={props.src} alt={props.alt} style={props.style}/>
      </>
    );
}

export default Image;